<template>
  <div class="box">
    <div class="headline">
      <span>tell us about</span>
      <span class="second-text-line">your nft</span>
    </div>
    <div
      class="input-box-wrapper"
      :class="[noWrapInputFile === true ? 'hide-box-in-input-file' : '']"
    >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: "InputFormBox",
  props: {
    noWrapInputFile: {
      type: Boolean,
      default: false,
    },
    hideText: {
      type: String,
      default: "",
    },
  },
  setup() {},
};
</script>
<style lang="scss" scoped src="@/Common/Styles/inputFormBox.scss"></style>
